import React from 'react';
import { LayoutDashboardIcon, UsersIcon, UserIcon, CalendarIcon, BriefcaseIcon, ShieldIcon, StethoscopeIcon, ContactIcon, TrendingUpIcon, SettingsIcon, LogOutIcon, FileTextIcon, Building2Icon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { hasPermission } from '../../types';
interface SidebarProps {
  currentModule: string;
  onModuleChange: (module: string) => void;
}
const menuItems = [{
  id: 'dashboard',
  label: 'Panel de Control',
  icon: LayoutDashboardIcon,
  permission: 'dashboard' as const
}, {
  id: 'patients',
  label: 'Pacientes',
  icon: UsersIcon,
  permission: 'patients' as const
}, {
  id: 'doctors',
  label: 'Doctores',
  icon: UserIcon,
  permission: 'doctors' as const
}, {
  id: 'appointments',
  label: 'Citas',
  icon: CalendarIcon,
  permission: 'appointments' as const
}, {
  id: 'clinical-history',
  label: 'Historial Clínico',
  icon: FileTextIcon,
  permission: 'clinicalHistory' as const
}, {
  id: 'services',
  label: 'Servicios',
  icon: BriefcaseIcon,
  permission: 'services' as const
}, {
  id: 'insurance',
  label: 'Seguros',
  icon: ShieldIcon,
  permission: 'insurance' as const
}, {
  id: 'specialties',
  label: 'Especialidades',
  icon: StethoscopeIcon,
  permission: 'specialties' as const
}, {
  id: 'contacts',
  label: 'Contactos',
  icon: ContactIcon,
  permission: 'contacts' as const
}, {
  id: 'companies',
  label: 'Empresas',
  icon: Building2Icon,
  permission: 'companies' as const
}, {
  id: 'opportunities',
  label: 'Oportunidades',
  icon: TrendingUpIcon,
  permission: 'opportunities' as const
}, {
  id: 'settings',
  label: 'Configuración',
  icon: SettingsIcon,
  permission: 'settings' as const
}];
export function Sidebar({
  currentModule,
  onModuleChange
}: SidebarProps) {
  const {
    logout,
    user
  } = useAuth();
  // Filter menu items based on user permissions
  const visibleMenuItems = menuItems.filter(item => {
    if (!user) return false;
    return hasPermission(user.role, item.permission, 'read');
  });
  return <aside className="w-64 h-screen bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex flex-col fixed left-0 top-0" data-id="element-66">
      {/* Logo */}
      <div className="p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-67">
        <div className="flex items-center gap-3" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/a741bfNsYBMGGZNxniTt4s/images.jpg" alt="Savidna Logo" className="w-10 h-10 rounded-full object-cover" data-id="element-69" />
          <div data-id="element-70">
            <h1 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-71">
              Savidna
            </h1>
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-72">
              CRM Médico
            </p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-4" data-id="element-73">
        <ul className="space-y-1 px-2" data-id="element-74">
          {visibleMenuItems.map(item => {
          const Icon = item.icon;
          const isActive = currentModule === item.id;
          return <li key={item.id} data-id="element-75">
                <button onClick={() => onModuleChange(item.id)} className={`
                    w-full flex items-center gap-3 px-3 py-2.5 rounded-lg
                    text-sm font-medium transition-colors
                    ${isActive ? 'bg-sky-50 text-sky-600 dark:bg-sky-900/20 dark:text-sky-400' : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'}
                  `} data-id="element-76">
                  <Icon className="w-5 h-5" data-id="element-77" />
                  {item.label}
                </button>
              </li>;
        })}
        </ul>
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-200 dark:border-gray-700" data-id="element-78">
        <button onClick={logout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20 transition-colors" data-id="element-79">
          <LogOutIcon className="w-5 h-5" data-id="element-80" />
          Cerrar Sesión
        </button>
      </div>
    </aside>;
}